export default __webpack_public_path__ + "static/font-7e698b12517525bfcca0208976e3cb4e.woff2";